<template>
  <DsPageLayout
    :theme="theme"
    prevent-loading
  >
    <!-- <template #cookie-bar>
        <PageCookieBar />
      </template> -->
    <template #header="{ headerTheme }">
      <LayoutPageHeader
        v-if="navigationData"
        :header-theme="headerTheme"
        :navigation-data="navigationData"
        :hide-search="false"
        hide-loading
        logo-as-nuxt-link
      />
      <div
        id="portal-header"
        ref="headerPortal"
        class="header-portal"
        @change="handleHeaderPortalUpdate($event, headerPortal)"
      />
      <DsNotificationBar
        v-if="notification"
        :close-conditions="{
          manual: true,
          auto: false,
          autoTime: 0 // ms
        }"
        :link="notification.link"
        :icon="notification.icon"
        @close="dismissNotification"
      />
    </template>
    <template #content>
      <div
        :style="{ paddingTop: `${headerPortalHeight}px` }"
        class="ds-width-full"
      >
        <slot />
      </div>
    </template>
    <template #footer>
      <LayoutPageFooter
        v-if="footerNavigationData"
        :footer-data="footerNavigationData"
      />
    </template>
    <template #overlay>
      <div id="portal-overlay" />
    </template>
    <!-- eslint-disable vue/no-v-html -->
    <div
      v-once
      v-html="noscriptHtml"
    />
    <!-- eslint-enable vue/no-v-html -->
  </DsPageLayout>
</template>

<script setup>
/**
 * Default Layout
 * will be used on pages where there is no custom layout set
 */
import { DsPageLayout, DsNotificationBar } from 'awds'

const GREY_THEME_PAGES = ['partners-network']

const headerPortal = ref()

const { handleHeaderPortalUpdate, headerPortalHeight, noscriptHtml } = useLayout()
const route = useRoute()
const { theme } = useTheme()
const { localeGlobalContentData } = useMainGlobalData()
const { notification, dismissNotification } = useNotificationBanner()

const navigationData = computed(() => localeGlobalContentData.value?.globalNavigationData?.main)
const footerNavigationData = computed(() => localeGlobalContentData.value?.globalFooterData?.main)

watchEffect(() => {
  if (GREY_THEME_PAGES.some((slug) => route.name?.includes(slug))) {
    theme.value = 'grey'
    return
  }

  theme.value = 'light'
})
</script>
